export default "__VITE_ASSET__DTkSk1Rn__"